import React from "react";
import ReportCard from "./ReportCard";
import CheckNutritionSection from "./CheckNutritionSection";
import { useReportMonk } from "../../context/reportMonk";
import { ReportsContainer } from "./shareStyledComponents";
import { toNumberFormat } from "../../utils/numberFormat";

const DayResult = () => {
  const { getCurrentDateInform } = useReportMonk();

  return (
    <>
      <ReportsContainer>
        <ReportCard
          title="ดื่มดี นมวัว"
          total={toNumberFormat(
            getCurrentDateInform("totalMilkVolume", 0) +
              getCurrentDateInform("totalSoyMilkVolume", 0)
          )}
          unit="ml"
          prefix="บริโภค "
          score={toNumberFormat(getCurrentDateInform("totalCowMilkScore", 0))}
        />
        <ReportCard
          title="สุขชัวร์ เพิ่มผัก"
          total={toNumberFormat(
            getCurrentDateInform("totalVegetableQuantity", 0)
          )}
          unit="ช้อนโต๊ะ"
          prefix="บริโภค"
          score={toNumberFormat(getCurrentDateInform("totalVegetableScore", 0))}
        />
        <ReportCard
          title="รัก ออกกำลัง"
          total={toNumberFormat(
            getCurrentDateInform("totalExerciseMinutes", 0)
          )}
          prefix="เวลา"
          unit="นาที"
          score={getCurrentDateInform("totalExerciseScore", 0)}
        />
        <ReportCard
          title="หยุดยั้ง น้ำหวาน"
          total={toNumberFormat(
            getCurrentDateInform("totalSweetDrinkVolume", 0)
          )}
          prefix="บริโภค น้ำหวาน"
          unit="ml"
          score={getCurrentDateInform("totalSweetDrinkScore", 0)}
        />
      </ReportsContainer>
      <CheckNutritionSection
        data={getCurrentDateInform("nutritionStatus", {
          weight: "-",
          height: "-",
          weightForHeight: "-",
          heightForAge: "-",
        })}
      ></CheckNutritionSection>
    </>
  );
};

export default DayResult;
